import "./dom_extend";


//
// Jedna položka v carouselu.
// Položka v carouselu se skládá ze "slide" (tj. to co, zobrazujeme) a "dot" (tj. navigace na tento snímek).
// "Dot" je volitelný (navigace není povinná) a fyzicky může mít libovolnou podobu (tj. nejen tečky, ale třeba
// i obrázkový náhled atd.).
//
function CarouselItem(slideElement, dotElement) {
	this.slide = slideElement;
	this.dot = dotElement;
}
CarouselItem.prototype = {
	constructor: CarouselItem,

	//
	// Přidá k slide i dot třídu nebo třídy (jsou jako volitelné argumenty).
	//
	addClass: function() {
		this.slide.classList.add.apply(this.slide.classList, arguments);
		if (this.dot) {
			this.dot.classList.add.apply(this.dot.classList, arguments);
		}
	},

	//
	// Odebere od slide a dot třídu nebo třídy (jsou jako volitelné argumenty).
	//
	removeClass: function() {
		this.slide.classList.remove.apply(this.slide.classList, arguments);
		if (this.dot) {
			this.dot.classList.remove.apply(this.dot.classList, arguments);
		}
	},

	//
	// Má slide danou třídu?
	// Stačí kontrolovat na slide, protože ten je (na rozdíl od dot) povinný a třídy
	// jsou u slide i dot vždy stejné.
	//
	containsClass: function(klass) {
		return this.slide.classList.contains(klass);
	},

	clearAnimation: function() {
		this.slide.style.animation = "none";
		this.slide.offsetHeight; // Reset
	},

	resumeAnimation: function() {
		this.slide.style.animation = null;
	}
};


//
// Carousel
//
export function Carousel(wrapper) {
	// Id intervalu pro autoplay (pro možnost zrušit interval).
	this.intervalId = null;

	// Autoplay buď může být dočasně pozastaven (např. při najetí myši) a nebo úplně zastaven (např. při kliknutí na navigaci).
	this.isAutoplayPaused = false;

	// [px] Kolik pixelů uživatel musí ujet prstem, aby byl pohyb rozpoznán jako tah.
	this.touchBound = 30;

	// X-ová pozice kliknutí (pro detekci gesta pohybu do stran - následující nebo předchozí slide).
	this.touchX = null;

	// [ms] Interval výměny slidů, má-li být autoplay aktivní.
	this.interval = wrapper.getAttribute("data-carousel-interval");

	// Je povoleno zastavení přehrávání při najetí myší?
	this.isPauseOnHoverEnabled = wrapper.getAttribute("data-carousel-pauseonhover") !== "false";

	// Kontejnery carouselu.
	this.wrapper = wrapper;
	this.container = wrapper.querySelector("[data-carousel='slides']");
	this.navigation = wrapper.querySelector("[data-carousel='dots']")

	// Slidy + navigační tlačítka.
	this.slides = this.container ? this.container.children : [];
	this.dots = this.navigation ? this.navigation.children : [];

	// Slidy uložíme do vlastní struktury pro snazší zacházení.
	// Navigační tečky nejsou povinné.
	this.items = [];
	for (var i = 0; i < this.slides.length; ++i) {
		this.items.push(new CarouselItem(
			this.slides[i],
			i < this.dots.length ? this.dots[i] : null
		));
	}

	// Registrace událostí.
	for (let button of wrapper.querySelectorAll("[data-carousel='prev']")) {
		button.addEventListener("click", this.onPrev.bind(this));
	}
	for (let button of wrapper.querySelectorAll("[data-carousel='next']")) {
		button.addEventListener("click", this.onNext.bind(this));
	}
	for (var i = 0; i < this.dots.length; ++i) {
		this.dots[i].addEventListener("click", this.onNavigation.bind(this));
	}

	// Události pro posun prstem.
	this.container.addEventListener("touchstart", this.onTouchStart.bind(this), { passive: true });
	this.container.addEventListener("touchmove", this.onTouchMove.bind(this), { passive: false });
	this.container.addEventListener("mouseenter", this.onMouseEnter.bind(this), { passive: true });
	this.container.addEventListener("mouseleave", this.resumeAutoplay.bind(this), { passive: true });

	// Nastartujme autoplay (je-li uživatelem definovaný).
	this.initByActive();
	this.startAutoplay();
}
Carousel.prototype = {
	constructor: Carousel,

	//
	// Posune se na nový slide.
	//
	move: function(index, direction, force) {
		var activeIndex = this.activeIndex;
		if (!force && index == activeIndex) {
			return;
		}

		// Pokud není směr zadán, zkusme si ho odvodit.
		if (!direction && activeIndex !== -1) {
			// Carousel je "nekonečný", zjistěme proto, kam se uživatel posouvá (zda vpřed nebo vzad).
			var forwardDistance = activeIndex < index ? index - activeIndex : this.items.length - activeIndex + index;
			var backwardDistance = activeIndex < index ? this.items.length - index + activeIndex : activeIndex - index;
			direction = forwardDistance <= backwardDistance ? "forward" : "backward";
		}

		if (0 <= activeIndex) {
			var activeItem = this.items[activeIndex];
			this.wrapper.trigger("carouselslidebefore", { item: activeItem });
		}

		for (var i = 0; i < this.items.length; ++i) {
			var item = this.items[i];
			item.removeClass("active", "last", "next", "forward", "backward");
			if (direction) {
				item.addClass(direction);
			}
			item.clearAnimation();
		}

		for (var i = 0; i < this.items.length; ++i) {
			var orderIndex = (index + this.items.length - (direction != "backward" ? 1 : 0) + i) % this.items.length;
			var item = this.items[orderIndex];
			item.slide.style.order = i;
		}

		var item = this.items[index];
		item.addClass("active");

		var prevItem = this.items[this.prevIndex(index)];
		if (item != prevItem) {
			prevItem.addClass("last");
		}

		var nextItem = this.items[this.nextIndex(index)];
		if (item != nextItem) {
			nextItem.addClass("next");
		}

		this.wrapper.trigger("carouselslide", { item: item });

		for (var i = 0; i < this.items.length; ++i) {
			var item = this.items[i];
			item.resumeAnimation();
		}
	},

	get activeIndex() {
		return Array.prototype.findIndex.call(this.slides, function(slide) {
			return slide.classList.contains("active");
		});
	},

	//
	// Další obrázek
	//
	next: function() {
		var newIndex = this.nextIndex(this.activeIndex);
		this.move(newIndex, "forward");
	},

	nextIndex: function(idx) {
		return (idx + 1) % this.items.length;
	},

	//
	// Předchozí obrázek
	//
	prev: function() {
		var newIndex = this.prevIndex(this.activeIndex);
		this.move(newIndex, "backward");
	},

	prevIndex: function(idx) {
		return (idx + this.items.length - 1) % this.items.length;
	},

	//
	// Handler kliknutí na tlačítko "další".
	//
	onNext: function(event) {
		event.preventDefault();
		this.stopAutoplay();
		this.next();
	},

	//
	// Handler kliknutí na tlačítko "předchozí".
	//
	onPrev: function(event) {
		event.preventDefault();
		this.stopAutoplay();
		this.prev();
	},

	//
	// Handler kliknutí na tlačítko snímku v navigaci.
	//
	onNavigation: function(event) {
		event.preventDefault();
		this.stopAutoplay();
		var newIndex = Array.prototype.indexOf.call(event.currentTarget.parentNode.children, event.currentTarget);
		this.move(newIndex, newIndex < this.activeIndex ? "backward" : "forward");
	},

	//
	// Handler dotyku prstem v carouselu.
	//
	onTouchStart: function(event) {
		this.touchX = event.touches[0].clientX;
	},

	//
	// Přesun na další snímek gestem prstu.
	//
	onTouchMove: function(event) {
		if (this.touchX !== null) {
			var x = event.touches[0].clientX;
			var difference = this.touchX - x;
			if (this.touchBound < Math.abs(difference)) {
				event.preventDefault();
				this.stopAutoplay();

				if (0 < difference) {
					this.next();
				}
				else {
					this.prev();
				}

				this.touchX = null;
			}
		}
	},

	//
	// Vstup myši
	//
	onMouseEnter: function(event) {
		if (this.isPauseOnHoverEnabled) {
			this.pauseAutoplay();
		}
	},

	//
	// Autoplay tick - přechod na další snímek po tiku časovače.
	//
	onTick: function() {
		if (!this.isAutoplayPaused) {
			this.next();
		}
	},

	//
	// Pokud je nějaký slide označený jako aktivní, nastartujeme na něj.
	//
	initByActive: function() {
		let activeIndex = this.activeIndex;
		if (activeIndex && 0 < activeIndex) {
			this.move(activeIndex, "forward", true);
		}
	},

	//
	// Spustí autoplay přehrávání.
	//
	startAutoplay: function() {
		if (this.interval && 1 < this.items.length) {
			this.stopAutoplay();
			this.intervalId = setInterval(this.onTick.bind(this), this.interval);
			this.container.classList.add("autoplay");
		}
	},

	//
	// Zastaví auto-přehrávání.
	//
	stopAutoplay: function() {
		if (this.intervalId) {
			clearInterval(this.intervalId);
			this.intervalId = null;
			this.container.classList.remove("autoplay");
		}
	},

	//
	// Pozastaví auto-přehrávání.
	//
	pauseAutoplay: function() {
		this.isAutoplayPaused = true;
	},

	//
	// Opětovně rozběhne auto-přehrávání (pouze v případě, že bylo "pauznuté").
	//
	resumeAutoplay: function() {
		this.isAutoplayPaused = false;
	}
};
